module.exports = __webpack_public_path__ + "static/media/group-photo.f46d9008.jpg";